function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Placeholder, Action, Offset, Errors } from '../commons/IntlMessages';
import OffsetInstanceModel from "../models/session/OffsetInstanceModel";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 会議配置オフセットモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示
   */

  Mode[Mode["Show"] = 1] = "Show";
})(Mode || (Mode = {}));
/**
 * 会議配置オフセットモーダルコンポーネント
 */


var SessionOffsetModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionOffsetModalComponent, _React$Component);

  var _super = _createSuper(SessionOffsetModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionOffsetModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionOffsetModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Show:
        _this.state = {
          Modal: null,
          Offset: new OffsetInstanceModel()
        };
        break;

      default:
        throw Error;
    }

    _this.onClosePrintQRWindow = _this.onClosePrintQRWindow.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * タイトルを更新します。
   *
   * @param e イベント
   */


  _createClass(SessionOffsetModalComponent, [{
    key: "updateTitle",
    value: function updateTitle(e) {
      var offset = this.state.Offset;
      offset.Title = e.target.value.substring(0, e.target.maxLength);
      this.setState({
        Offset: offset
      });
    }
    /**
     * X軸オフセットを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateOffsetX",
    value: function updateOffsetX(e) {
      var offset = this.state.Offset;
      offset.OffsetX = Number(e.target.value);
      this.setState({
        Offset: offset
      });
    }
    /**
     * Y軸オフセットを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateOffsetY",
    value: function updateOffsetY(e) {
      var offset = this.state.Offset;
      offset.OffsetY = Number(e.target.value);
      this.setState({
        Offset: offset
      });
    }
    /**
     * Z軸オフセットを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateOffsetZ",
    value: function updateOffsetZ(e) {
      var offset = this.state.Offset;
      offset.OffsetZ = Number(e.target.value);
      this.setState({
        Offset: offset
      });
    }
    /**
     * 「作成」ボタン押下時の処理を行います。
     */

  }, {
    key: "onCreate",
    value: function onCreate() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.openPrintQRWindow();
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.onunload = function () {
        if (_this2.printQRWindow != null) {
          _this2.printQRWindow.close();

          _this2.printQRWindow = null;
        }
      };

      var modal = $('#SessionOffsetModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * 会議QR印刷ウィンドウを表示します。
     */

  }, {
    key: "openPrintQRWindow",
    value: function openPrintQRWindow() {
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        if (!this.printQRWindow || this.printQRWindow.closed) {
          var event = document.createEvent('Event');
          event.initEvent('onupdateposition', true, true);
          this.printQRWindow = window.open('Print', 'printqrcode', 'width=595,height=842');
        }
      }
    }
    /**
     * 会議QR印刷ウィンドウを閉じます。
     */

  }, {
    key: "onClosePrintQRWindow",
    value: function onClosePrintQRWindow() {
      this.printQRWindow = null;
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _this$state$Offset$Of,
          _this$state$Offset$Of2,
          _this$state$Offset$Of3;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionOffsetModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "offset",
        name: "offset",
        value: JSON.stringify(this.state.Offset)
      }), /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/qrcode.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Offset.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6 leftArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 modal-image-frame"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modal-image",
        src: "/assets/img/Image_QRPlacement.png"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-6 rightArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto model-offset-margin"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 model-offset-message-label"
      }, intl.format(Offset.OffsetMessage))), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto model-offset-margin"
      }, /*#__PURE__*/React.createElement("div", {
        className: "model-offset-title-label"
      }, intl.format(Offset.OffsetTitle)), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "Title",
        id: "Title",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 10,
        onChange: function onChange(e) {
          return _this3.updateTitle(e);
        },
        value: this.state.Offset.Title,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "10"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Title",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 model-offset-middle"
      }, intl.format(Offset.OffsetValueTitle))), /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "model-offset-box model-offset-margin"
      }, /*#__PURE__*/React.createElement("div", {
        className: "model-offset-title"
      }, "X:"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control model-offset-value",
        name: "OffsetX",
        id: "OffsetX",
        onChange: function onChange(e) {
          return _this3.updateOffsetX(e);
        },
        value: (_this$state$Offset$Of = this.state.Offset.OffsetX) !== null && _this$state$Offset$Of !== void 0 ? _this$state$Offset$Of : 0,
        tabIndex: 102,
        placeholder: intl.format(Placeholder.Letters, {
          value: "10"
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "model-offset-box model-offset-margin"
      }, /*#__PURE__*/React.createElement("div", {
        className: "model-offset-title"
      }, "Y:"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control model-offset-value",
        name: "OffsetY",
        id: "OffsetY",
        onChange: function onChange(e) {
          return _this3.updateOffsetY(e);
        },
        value: (_this$state$Offset$Of2 = this.state.Offset.OffsetY) !== null && _this$state$Offset$Of2 !== void 0 ? _this$state$Offset$Of2 : 0,
        tabIndex: 103,
        placeholder: intl.format(Placeholder.Letters, {
          value: "10"
        })
      })), /*#__PURE__*/React.createElement("div", {
        className: "model-offset-box model-offset-margin"
      }, /*#__PURE__*/React.createElement("div", {
        className: "model-offset-title"
      }, "Z:"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        className: "form-control model-offset-value",
        name: "OffsetZ",
        id: "OffsetZ",
        onChange: function onChange(e) {
          return _this3.updateOffsetZ(e);
        },
        value: (_this$state$Offset$Of3 = this.state.Offset.OffsetZ) !== null && _this$state$Offset$Of3 !== void 0 ? _this$state$Offset$Of3 : 0,
        tabIndex: 104,
        placeholder: intl.format(Placeholder.Letters, {
          value: "10"
        })
      })))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer modal-footer-container justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        id: "onCreate",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onCreate.bind(this),
        tabIndex: 200
      }, intl.format(Action.Create))))));
    }
  }]);

  return SessionOffsetModalComponent;
}(React.Component);

export { SessionOffsetModalComponent as default };